export const Marquee = ({ items, dark = false, testId = "editorial-marquee" }) => {
  const row = [...items, ...items, ...items];
  return (
    <div
      data-testid={testId}
      className={`overflow-hidden border-y border-ink ${dark ? "bg-ink text-bone" : "bg-bone text-ink"}`}
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center py-4 md:py-5">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={i} className="flex items-center font-oswald font-medium uppercase tracking-tight text-lg md:text-2xl whitespace-nowrap">
                <span className="px-6 md:px-10">{item}</span>
                <span className="h-2 w-2 shrink-0 bg-orange" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
